
import { ref, reactive, computed, defineAsyncComponent } from 'vue'
import { useStore } from 'vuex'
import CbimSteps from '@/components/CbimSteps/CbimSteps.vue'
import { getUrlQuery } from '@/utils/utils'
import { useI18n } from 'vue-i18n'

interface Payload {
    active: number
    accountVal?: string
    verifyCodeVal?: string
    bindSuccess?: boolean
    countryCode?: string
    type?: string
}

export default {
    name: 'UserBind',
    components: {
        CbimSteps,
        InputAccountStep: defineAsyncComponent(() => import('@/components/CbimSteps/InputAccountStep.vue')),
        SecurityVerificationStep: defineAsyncComponent(() => import('@/components/CbimSteps/SecurityVerificationStep.vue'))
    },
    setup() {
        const { t, locale } = useI18n()
        const currentLanguage = ref(locale)
        const currentStep = ref(0)
        const stepsTitle = reactive([t('message.shuruzhanghao'), t('message.anquanyanzheng')])
        
        // 支持从URL参数设置当前步骤
        let active: number = 0
        if (getUrlQuery('active')) {
            active = JSON.parse(getUrlQuery('active') as string)
        }
        currentStep.value = active
        
        const currentComponent = computed(() => {
            const componentList = ['InputAccountStep', 'SecurityVerificationStep']
            return componentList[currentStep.value]
        })

        const store = useStore()
        const account = ref('')
        const verifyCode = ref('')
        const countryCode = ref(store.state.countryCode || '+86')
        const type = ref('')
        
        const handleNextProcess = ({ accountVal, active, verifyCodeVal, bindSuccess, countryCode: receivedCountryCode, type: receivedType }: Payload) => {
            if (accountVal && accountVal !== '') {
                account.value = accountVal
            }
            if (verifyCodeVal && verifyCodeVal !== '') {
                verifyCode.value = verifyCodeVal
            }
            if (receivedCountryCode && receivedCountryCode !== '') {
                countryCode.value = receivedCountryCode
            }
            if (receivedType && receivedType !== '') {
                type.value = receivedType
            }
            currentStep.value = active
            
            // 处理用户绑定成功
            if (bindSuccess) {
                // 可以在这里添加绑定成功后的逻辑，比如跳转到其他页面
                console.log('用户绑定成功，账号:', accountVal)
            }
        }
        
        return {
            currentLanguage,
            currentComponent,
            currentStep,
            stepsTitle,
            account,
            verifyCode,
            countryCode,
            type,
            handleNextProcess
        }
    }
}
